module.exports = __webpack_public_path__ + "img/promo2.8822d2e5.jpg";